import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawSdvTri1Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "sdv-tri-1";
		this.icon = svg_sdv_tri_1;
	}
}

window.customElements.define("inspx-draw-sdv-tri-1-module", DrawSdvTri1Module);

const svg_sdv_tri_1 = html`
<svg width="60" height="60" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect stroke="#444444" id="svg_8" x="30.06622" y="0.43508" fill="#ffffff" width="29.69966" height="29.59955"/>
  <rect x="0.17798" y="29.72241" fill="#ffffff" width="59.53787" height="30" id="svg_2" stroke="#444444"/>
  <rect id="svg_5" height="29.23297" width="29.49994" y="30.16015" x="0.20544" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" stroke="#444444" fill="#aaa7a7"/>
  <line fill="none" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x1="30.17798" y1="59.72241" x2="30.17798" y2="29.72241" id="svg_1" stroke="#444444"/>
  <text fill="#000000" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="19.17705" y="52.88717" id="svg_4" font-size="24" font-family="Sans-serif" text-anchor="middle" xml:space="preserve" transform="matrix(1.748146119803863,0,0,1,-3.435311616745808,0) " stroke="#444444">VD</text>
  <text fill="#000000" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="27.78748" y="22.97447" font-size="24" font-family="Sans-serif" text-anchor="middle" xml:space="preserve" transform="matrix(1.748146119803863,0,0,1,-3.435311616745808,0) " stroke="#444444" id="svg_3">S</text>
  <line fill="none" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x1="30.10162" y1="30.03463" x2="30.10162" y2="0.03463" stroke="#444444" id="svg_6"/>
 </g>
</svg>`;
